import { render, staticRenderFns } from "./leaderboard-events-card.vue?vue&type=template&id=3887dd7a&scoped=true&"
import script from "./leaderboard-events-card.vue?vue&type=script&lang=js&"
export * from "./leaderboard-events-card.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-events-card.vue?vue&type=style&index=0&id=3887dd7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887dd7a",
  null
  
)

export default component.exports